// GUNDI-5639, TEMPORARY (v1 of the dual-UI trial — remove with the trial).
//
// Before Routes and Connections were separate screens, a "connection" WAS what
// we now call a route, and its URL carried the PROVIDER integration id. Those
// ids still resolve as connections, so old links used to land on the connection
// screen instead of the route the author meant. For v1 they redirect: a
// connection that provides data to at least one route sends /connections/:id to
// that route.
//
// Deliberately narrow, because the cost of being wrong is an unreachable page:
//   - only the bare /connections/:id path — /connections/:id/configuration and
//     /connections/:id/routes still open the connection's own tabs, so nothing
//     becomes unreachable;
//   - only the canonical path — the same screen also mounts under
//     /sources/destination/:id and /routes/:rid/:subpage/:id, where a jump to a
//     route would be nonsense;
//   - only on a SUCCEEDED lookup — treating a failed request as "has routes"
//     (or as "has none") is how this codebase has made wrong turns before.
// Ambiguity (a provider feeding several routes) resolves to the first route,
// the same default the version banner uses.
export type ProviderRoleLookup = {
    loaded: boolean;
    failed: boolean;
    routes: { id?: string }[];
};

export function providerRouteRedirectTarget(
    pathname: string,
    destId: string | undefined,
    providerRole: ProviderRoleLookup,
): string | null {
    // Trailing slashes are dropped: the router treats /connections/:id/ as the
    // same match, so the redirect must too.
    if (!destId || pathname.replace(/\/+$/, "") !== `/connections/${destId}`) return null;
    if (!providerRole.loaded || providerRole.failed) return null;
    const routeId = providerRole.routes[0]?.id;
    return routeId ? `/routes/${routeId}` : null;
}
